// extracted by mini-css-extract-plugin
export default {"airplaneSizingContainer":"naa-z","narrowOptionButtons":"oaa-z","noOptions":"paa-z"};